import { randomHEXColor } from "../../general/functions";
import { BASE_URL } from "../../general/variables";

/**
 * Cur Hex
 * 
 * ['#20B2AA',
                        '#FF0000',
                        '#00FF00',
                        '#0000FF',
                        '#00FFFF',
                        '#FF00FF',
                        '#FFA500',
                        '#008000',
                        '#800080',
                        '#FFC0CB',
                        '#FF4500',
                        '#32CD32',
                        '#20B2AA',
                        '#00CED1',
                        '#FF6347',
                        '#8A2BE2',
                        '#FFD700',
                        '#00FF7F',
                        '#FFD700',
                        '#4B0082 '],
 * 
 * 
 */

function generateBarTemplate(type, cat, title) {
  let curChart;

  const curColours = ['#FF5733', '#28CC48', '#3357FF', '#FF33A1', '#FFA833', '#33FF99', '#A833FF', '#33FFF9', '#FFD433', '#FF3357', '#57FF33', '#33D4FF', '#FF33D4', '#33FFA8', '#FFA833', '#33A8FF', '#A8FF33', '#FF5733', '#57A8FF', '#D433FF'];

  switch (type) {
    case 'bar':
      curChart = {
        series: [],
        chart: {
          height: 380,
          type: 'bar',
          toolbar: {
            show: false, // This will hide the entire toolbar
          },
        },
        menu: {
          show: false,
        },
        colors: curColours,
        theme: {
          mode: 'light',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val;
          },
          style: {
            fontSize: '12px',
            colors: ['#304758'],
          },
        },
        xaxis: {
          categories: cat,
          position: 'bottom',
          axisBorder: {
            show: true,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              },
            },
          },
          tooltip: {
            enabled: true,
          },
        },
        noData: {
          text: 'No Data',
          align: 'center',
          verticalAlign: 'center',
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return val;
            },
          },
        },
        title: {
          text: title,
          align: 'center',
          style: {
            color: '#444',
          },
        },
      };
      break;
    case 'heatmap':
      curChart = {
        series: [],
        colors: curColours,
        chart: {
          height: 380,
          type: 'heatmap',
          toolbar: {
            show: false, // This will hide the entire toolbar
          },
        },
        theme: {
          mode: 'light',
        },
        dataLabels: {
          enabled: false,
        },
        noData: {
          text: 'No Data',
          align: 'center',
          verticalAlign: 'center',
        },
        xaxis: {
          type: 'category',
          categories: cat,
        },
        stroke: {
          width: 1,
        },
        tooltip: {
          x: {
            formatter: function (val) {
              return 'Time of registration: ' + val;
            },
          },
          y: {
            formatter: function (val) {
              return val + ' students';
            },
          },
        },
        title: {
          floating: true,
          offsetY: 360,
          align: 'center',
          style: {
            color: '#444',
          },
        },
      };
      break;
    case 'line':
      curChart = {
        series: [],
        chart: {
          height: 350,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
            tools: {
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
            },
          },
        },
        colors: curColours,
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: 'smooth',
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: cat,
          title: {
            text: 'Date',
          },
        },
        yaxis: {
          title: {
            text: 'Numbers',
          },
          min: 5,
        },
      };
      break;
    case 'radial':
      curChart = {
        series: [],
        chart: {
          height: 455,
          type: 'radialBar',
          toolbar: {
            show: false, // This will hide the entire toolbar
          },
        },
        colors: curColours,

        theme: {
          mode: 'light',
        },
        noData: {
          text: 'No Data',
          align: 'center',
          verticalAlign: 'center',
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: '30%',
              background: 'transparent',
              image: undefined,
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        labels: cat,
        legend: {
          show: false,
          floating: true,
          fontSize: '12px',
          position: 'left',
          offsetX: 160,
          offsetY: 15,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 0,
          },
          formatter: function (seriesName, opts) {
            return seriesName + ':  ' + opts.w.globals.series[opts.seriesIndex];
          },
          itemMargin: {
            vertical: 3,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false,
              },
            },
          },
        ],
      };
      break;
    case 'pie':
      curChart = {
        series: [],
        theme: {
          mode: 'light',
        },
        colors: curColours,
        chart: {
          width: '100%',
          type: 'pie',
          toolbar: {
            show: false, // This will hide the entire toolbar
          },
        },
        noData: {
          text: 'No Data',
          align: 'center',
          verticalAlign: 'center',
        },
        labels: cat,
      };
      break;
    case 'radialBar':
      curChart = {
        series: [],
        theme: {
          mode: 'light',
        },
        chart: {
          height: 350,
          type: 'radialBar',
          toolbar: {
            show: false, // This will hide the entire toolbar
          },
        },
        colors: curColours,

        plotOptions: {
          radialBar: {
            hollow: {
              size: '70%',
            },
            barLabels: {
              enabled: true,
              useSeriesColors: true,
              offsetX: -8,
              fontSize: '16px',
              formatter: function (seriesName, opts) {
                return seriesName + ':  ' + parseInt(opts.w.globals.series[opts.seriesIndex]).toLocaleString('id-ID');
              },
            },
          },
        },
        noData: {
          text: 'No Data',
          align: 'center',
          verticalAlign: 'center',
        },
        labels: title,
      };
      break;
    case 'barChart':
      curChart = {
        series: [
          {
            data: [],
          },
        ],
        noData: {
          text: 'No Data',
          align: 'center',
          verticalAlign: 'center',
        },
        colors: curColours,
        theme: {
          mode: 'light',
          // palette: 'palette6'
        },
        chart: {
          type: 'bar',
          height: 350,
          toolbar: {
            show: false, // This will hide the entire toolbar
          },
        },
        menu: {
          show: false,
        },
        plotOptions: {
          bar: {
            barHeight: '100%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom',
            },
          },
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#373D3F'],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
            top: 1,
            left: 1,
            blur: 1,
            color: '#fff',
            opacity: 0.25,
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false, // hide the x-axis line when there's no data
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false, // hide the x-axis line when there's no data
          },
        },
        tooltip: {
          theme: 'dark',
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: function () {
                return '';
              },
            },
          },
        },
      };
      break;
    case 'expectedChart':
      curChart = {
        series: [],
        colors: curColours,
        theme: {
          mode: 'light',
        },
        chart: {
          height: 350,
          type: 'bar',
          toolbar: {
            show: false, // This will hide the entire toolbar
          },
        },
        menu: {
          show: false,
        },
        noData: {
          text: 'No Data',
          align: 'center',
          verticalAlign: 'center',
        },
      };
      break;
  }

  return curChart;
}

async function generateBarData(type, chart, id, leads_score = 'ALL') {
  let res;

  try {
    switch (type) {
      case 'hourly':
        res = await $.post(BASE_URL + 'AnalyticsController/getHourlyData', {
          id: id,
          type: chart,
          leads_score: leads_score,
        });

        break;

      case 'staging':
        res = await $.post(BASE_URL + 'AnalyticsController/getConversionData', {
          type: chart,
          leads_score: leads_score,
        });

        break;

      case 'monthly':
        res = await $.post(BASE_URL + 'AnalyticsController/getMonthlyData', {
          type: chart,
          leads_score: leads_score,
        });

        break;

      case 'daily':
        res = await $.post(BASE_URL + 'AnalyticsController/getDailyData', {
          id: id,
          type: chart,
          leads_score: leads_score,
        });

        break;
      case 'radial':
        res = await $.post(BASE_URL + 'AnalyticsController/getRadialData', {
          id: id,
          leads_score: leads_score,
        });

        break;
      case 'pie':
        res = await $.post(BASE_URL + 'AnalyticsController/getPieData', {
          id: id,
          type: chart,
          leads_score: leads_score,
        });

        break;
      case 'bar':
        res = await $.post(BASE_URL + 'AnalyticsController/getBarData', {
          id: id,
          type: chart,
          leads_score: leads_score,
        });

        break;
    }
  } catch (ex) {
    res = {
      code: 204,
      message: ex,
    };
  }

  return res;
}

function renderChartData(el, options) {
  el.updateOptions(options);
}

export { generateBarData, generateBarTemplate, renderChartData };
